import React from "react";

const decimalSeparator = window.___APP_CONFIG___.DECIMAL_SEPARATOR == "," ? "," : ".";
const thousandSeparator = window.___APP_CONFIG___.DECIMAL_SEPARATOR == "," ? "." : ",";

//PRE: Receives a float/int value and two int min and max values
//POS: Returns value with specific decimal and thousands separators and min and max decimal numbers.
export const formattedNumber = (value, minimumFractionDigits, maximumFractionDigits) => {
  let isNegative = false;
  let res = "" + value;
  res = res.trim();
  if (value === null || value === undefined || value === "") return "";

  //If it's negative we'll ignore the - sign until the end.
  if (value < 0) {
    isNegative = true;
    res = value * -1 + "";
  }

  //Here we change the decimals.
  if (res.includes(".")) {
    let resDec = res.split(".")[1];

    //Decimal numbers must be between the min and the max
    if (minimumFractionDigits != undefined && maximumFractionDigits != undefined) {
      if (minimumFractionDigits === maximumFractionDigits) {
        if (minimumFractionDigits === 0 && maximumFractionDigits === 0) {
          res = Math.round(res) + "";
        } else {
          res = parseFloat(res).toFixed(minimumFractionDigits) + "";
        }
      } else if (resDec.length < minimumFractionDigits) {
        res = parseFloat(res).toFixed(minimumFractionDigits) + "";
      } else if (resDec.length > maximumFractionDigits) {
        res = parseFloat(res).toFixed(maximumFractionDigits) + "";
      }
    } //Decimal numbers must be at least as long as the min, with no limit.
    else if (minimumFractionDigits && !maximumFractionDigits) {
      if (resDec.length < minimumFractionDigits) {
        res = parseFloat(res).toFixed(minimumFractionDigits) + "";
      }
    } //Value can have zero fraction digits, but it has a max
    else if (!minimumFractionDigits && maximumFractionDigits) {
      if (resDec.length > maximumFractionDigits) {
        res = parseFloat(res).toFixed(maximumFractionDigits) + "";
      }
    }
    //If there's no min and max value stays as it is.
  }

  //Here we change the decimal and thousands separators.
  if (res.includes(".")) {
    res = res.split(".");
    if (thousandSeparator === ".") {
      res = parseInt(res[0]).toLocaleString("es-ES") + decimalSeparator + res[1];
    } else {
      res = parseInt(res[0]).toLocaleString("en-US") + decimalSeparator + res[1];
    }
  } else {
    if (thousandSeparator === ".") {
      res = parseInt(res).toLocaleString("es-ES");
    } else {
      res = parseInt(res).toLocaleString("en-US");
    }
  }

  //If value is a 4 digit number we have to manually add a thousand separator
  if (
    (res.includes(decimalSeparator) && res.split(decimalSeparator)[0].length === 4) ||
    (!res.includes(decimalSeparator) && res.length === 4)
  ) {
    res = res.split("")[0] + thousandSeparator + res.substr(1, res.length);
  }

  if (isNegative && parseFloat(res) != 0) res = "-" + res;
  return res;
};

//PRE: Receives a float/int value and two int min and max values
//POS: Returns value with specific decimal and thousands separators and min and max decimal numbers.
export const FormattedNumber = ({ value, minimumFractionDigits, maximumFractionDigits }) => {
  let isNegative = false;
  let res = "" + value;
  res = res.trim();
  if (value === null || value === undefined || value === "" || isNaN(res)) return <span>-</span>;

  //If it's negative we'll ignore the - sign until the end.
  if (value < 0) {
    isNegative = true;
    res = value * -1 + "";
  }

  //Here we change the decimals.
  if (res.includes(".")) {
    let resDec = res.split(".")[1];

    //Decimal numbers must be between the min and the max
    if (minimumFractionDigits != undefined && maximumFractionDigits != undefined) {
      if (minimumFractionDigits === maximumFractionDigits) {
        if (minimumFractionDigits === 0 && maximumFractionDigits === 0) {
          res = Math.round(res) + "";
        } else {
          res = parseFloat(res).toFixed(minimumFractionDigits) + "";
        }
      } else if (resDec.length < minimumFractionDigits) {
        res = parseFloat(res).toFixed(minimumFractionDigits) + "";
      } else if (resDec.length > maximumFractionDigits) {
        res = parseFloat(res).toFixed(maximumFractionDigits) + "";
      }
    } //Decimal numbers must be at least as long as the min, with no limit.
    else if (minimumFractionDigits && !maximumFractionDigits) {
      if (resDec.length < minimumFractionDigits) {
        res = parseFloat(res).toFixed(minimumFractionDigits) + "";
      }
    } //Value can have zero fraction digits, but it has a max
    else if (!minimumFractionDigits && maximumFractionDigits) {
      if (resDec.length > maximumFractionDigits) {
        res = parseFloat(res).toFixed(maximumFractionDigits) + "";
      }
    }
    //If there's no min and max value stays as it is.
  } else {
    res = parseFloat(res).toFixed(minimumFractionDigits) + "";
  }

  //Here we change the decimal and thousands separators.
  if (res.includes(".")) {
    res = res.split(".");
    if (thousandSeparator === ".") {
      res = parseInt(res[0]).toLocaleString("es-ES") + decimalSeparator + res[1];
    } else {
      res = parseInt(res[0]).toLocaleString("en-US") + decimalSeparator + res[1];
    }
  } else {
    if (thousandSeparator === ".") {
      res = parseInt(res).toLocaleString("es-ES");
    } else {
      res = parseInt(res).toLocaleString("en-US");
    }
  }

  //If value is a 4 digit number we have to manually add a thousand separator
  if (
    (res.includes(decimalSeparator) && res.split(decimalSeparator)[0].length === 4) ||
    (!res.includes(decimalSeparator) && res.length === 4)
  ) {
    if (thousandSeparator === ".") {
      res = res.split("")[0] + thousandSeparator + res.substr(1, res.length);
    } else {
      res = res.split("")[0] + thousandSeparator + res.substr(1, res.length);
    }
  }

  if (isNegative && parseFloat(res) != 0) res = "-" + res;
  return <span>{res}</span>;
};
